<!-- rooming.svelte -->
<script>
	import {API,http_headers, toDate,get_semanas} from '../global.js'
	import {onMount} from 'svelte'
	import ReservaInfo from './reserva-info.svelte'

	let complejo = 1
	let semana1 = 1
	let semana2 = 1
	let year = (new Date).getFullYear()
	let tabla_semanas = []
	let sem_actual = []
	let ds = []
	let rooming = []
	let loading = false
	let voucher_selected = 0


	let key = 'APyNOM'
	let pattern = ''
	let stats = {}
	let verStats = false
	let Q = [0,700,602]
	let verObsV= 0

	$: fecha1 = tabla_semanas.length ? tabla_semanas.filter( (e) => e.semana==semana1 )[0]?.sa : ''
	$: fecha2 = tabla_semanas.length ? tabla_semanas.filter( (e) => e.semana==semana2 )[0]?.sa2 : ''

	const make_table = () => {
		tabla_semanas = get_semanas(year)
	//	console.log(tabla_semanas)
	}

	const check_semana2 = () => {
		semana2 = semana1 //semana2<semana1 ? semana1 : semana2
	}

	onMount( async () => {
		tabla_semanas = get_semanas(year)
		sem_actual = tabla_semanas.filter( (e) => e.actual )
		semana1 =  sem_actual[0]?.semana || 1
		semana2 = semana1
	})

	const get_rooming = async() => {
		key = 'APyNOM'
		pattern = ''
		rooming = []	
		if(fecha1 && fecha2){
			loading = true
			rooming = []
			let query = `SELECT '....' AS 'PA', vistavoucher.Unidad AS 'COD', '  ' AS 'UNIDAD', vistavoucher.IdVoucher AS 'RVA',
        vistavoucher.IdNroVoucher AS 'VOUCHER', vistavoucher.TipoAgente AS 'STATUS',vistavoucher.EstadoVoucher AS 'estado',
        vistavoucher.IdCliente AS 'SOCIO',vistavoucher.IdClienteUsuario as 'IDCU', vistavoucher.ClienteUsuario AS 'APyNOM', convert(varchar(10),vistavoucher.Llegada,103) AS 'CHECKIN', convert(varchar(10),vistavoucher.Salida,103) AS 'CHECKOUT', vistavoucher.Observacion AS 'OBS', vistavoucher.Adultos AS 'PAX',Adultos,Menores,CantidadFlex,AdultosFlex
        	,datediff(d,case when llegada<'${fecha1}' then '${fecha1}' else llegada end,case when salida>'${fecha2}' then '${fecha2}' else salida end) as cantidad, vistavoucher.Observacionvoucher AS 'OBSV'
		FROM Gescom.dbo.vistavoucher vistavoucher
		WHERE (vistavoucher.Salida>DATEADD(hour,15,'${fecha1}')) AND (vistavoucher.Llegada<=dateadd(hour,10,'${fecha2}')) AND (vistavoucher.IdHotel=${complejo})
		ORDER BY vistavoucher.Hotel, vistavoucher.Unidad`

			const res = await fetch(`${API}/exec-query?u=true`,
				{
					method:'POST',
					headers: http_headers,
					body:JSON.stringify({query})	
				})
			const data = await res.json()
			
			if(data.success) {
				ds = data.data
				rooming = ds || []
				loading = false
			}
			else{
				throw new Error(data)
				loading = false
			} 
		}else{
			alert("Error semana ingresada")
		}
	}

	function buscar(k){
		key = k
		aplicar()
	}

	function aplicar(){
		pattern=pattern.trim()
		if(pattern !== ''){
			loading = true
			rooming = ds.filter(v => (v[key]||'').toString().toUpperCase().includes(pattern.toString().toUpperCase()))
			loading = false
		}else rooming = ds
	}

	function limpiar(){
		pattern = ''
		rooming = ds
	}

	function ocupacion() {
		return ds.reduce( (tot,v) => tot+v.cantidad, 0)
	}

	function estadisticas(){
		verStats = false
		let stat = ds.reduce( (t, v) => {
			t[v.STATUS] = [...t[v.STATUS] || [], v]
			return t
		}, [] )
		
		stats = []
		for(let x of Object.keys(stat)){
			let qtty = stat[x].reduce( (t,v) => t+v.cantidad,0)
			let elem = {}
			elem = {tipo:x,cantidad:qtty,ocupacion:Q[complejo]}
			stats.push(elem)  
		}
		verStats = true
	}

	function closeStats(){
		stats = []
		verStats = false
	}

	let nomcom = ['No Definido','RDA','RDE']
	let	txtFile = ''

	function descargar(){
		txtFile = `PA;COD;UNIDAD;RVA;VOUCHER;STATUS;SOCIO;APyNOM;CHECKIN;CHECKOUT;OBS;PAX\n`
		rooming.forEach( (linea,li) => {
			//console.log(linea)
			txtFile = txtFile + `${linea.PA};${linea.COD};${linea.UNIDAD};${linea.RVA};${linea.VOUCHER};${linea.STATUS};${linea.SOCIO};${linea.APyNOM.replace(';',',')||''};${linea.CHECKIN};${linea.CHECKOUT};${linea.OBS.replace(';',',')};${linea.Adultos+linea.Menores} ${linea.CantidadFlex?' (F'+ linea.AdultosFlex +')':''};${linea.cantidad}\n`

		})

		const textToBLOB = new Blob([txtFile], { type: 'text/csv' });
        const sFileName = `Rooming ${nomcom[complejo]} sem${semana1} ${Date.now()}.csv`;

        let newLink = document.createElement("a");
        newLink.download = sFileName;

        if (window.webkitURL != null) {
            newLink.href = window.webkitURL.createObjectURL(textToBLOB);
        }
        else {
            newLink.href = window.URL.createObjectURL(textToBLOB);
            newLink.style.display = "none";
            document.body.appendChild(newLink);
        }

        newLink.click(); 
	}

	function preasignar(rva){
		//alert(`Preasinacion RVA:${rva}\nNo disponible, consultar a Sistemas!`)
		voucher_selected = rva * 1
	}

</script>

{#if verStats}
	
	<div class="offcanvas offcanvas-end show" tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel" style="visibility: visible;">
	  	<div class="offcanvas-header">
			<div class="row">	
				<button class="btn btn-danger" on:click={closeStats}><b>&times;</b></button>
			</div>
		</div>

		<div class="offcanvas-body">
			<!-- <pre>{JSON.stringify(stats,null,2)}</pre> -->
			{#each stats as item, index}
				<div class="row border-bottom my-1">
					<div class="col">{item.tipo}</div>
					<div class="col text-end">{item.cantidad}</div>
					<div class="col text-end">{(item.cantidad/item.ocupacion*100).toFixed(2)}%</div>
				</div>
			{/each}
			<div class="row my-2 py-2 bg-light">
				<div class="col"></div>
				<div class="col text-end">
					<b>{ocupacion()}</b> 
				</div>
				<div class="col text-end">
					<b>{(parseInt(ocupacion())/Q[complejo]*100).toFixed(2)}%</b>
				</div>
			</div>
		</div>
	</div>

{/if}

<div class="container-fluid mt-2">

	<div class="row text-end">
		<div class="col-12 text-muted">
			<i><small>{`Semana actual : ${sem_actual[0]?.semana} (${sem_actual[0]?.sa} a ${sem_actual[0]?.vi})`}</small></i>
		</div>
		</div>

	<div class="row">
		<div class="col-2">Complejo</div>
		<div class="col-4">
			<div class="form-check form-check-inline">
			  <input bind:group={complejo} value="{1}" class="form-check-input" type="radio" name="complejo" id="rda">
			  <label class="form-check-label" for="rda">RDA</label>
			</div>
			<div class="form-check form-check-inline">
			  <input bind:group={complejo} value="{2}" class="form-check-input" type="radio" name="complejo" id="rde">
			  <label class="form-check-label" for="rde">RDE</label>
			</div>
		</div>
	</div>

	<div class="row border-bottom pb-3">
		<div class="col-2">Semana</div>
		<div class="col-auto">
			<input size=4 type="text" class="form-control form-control-sm" bind:value={year} aria-label="year" on:change={make_table} tabindex="-1">
		</div>
		<div class="col-auto">
			<input size=2 type="text" class="form-control form-control-sm" bind:value={semana1} aria-label="semana1" on:change={check_semana2}>
		</div>
		<div class="col-auto text-end">
			<button class="btn btn-sm btn-primary" on:click={get_rooming}>Aceptar</button>
		</div>
		<div class="col-auto">
			<span class="p-2">{fecha1}</span>
			<span class="p-2">{fecha2}</span>
		</div>

	</div>
	
	<div class="row">
		{#if loading}
			<div class="d-flex mt-4">
				<div class="spinner-border" role="status">
					<span class="visually-hidden">Loading...</span>
				</div>
			</div>
		{:else if ds.length}
			<div class="row my-1">
				<div class="col-6">
					{key}<input bind:value={pattern} class="mx-2" on:change={aplicar} placeholder="buscar" />
					<button on:click={limpiar}>&times;</button>
					<span class="text-end ms-4">{rooming.length||''}/{ds.length||''}</span>
				</div>
				<div class="col-6 text-end">
					<button class="btn btn-sm btn-primary" on:click={estadisticas} title="Ocupacion">
						{ocupacion()} ({(parseInt(ocupacion())/Q[complejo]*100).toFixed(2)}%)
					</button>
					<button class="btn btn-sm btn-secondary" on:click={descargar} title="Descargar rooming"><i class="bi bi-download"></i></button>
					<!-- <button class="btn btn-sm btn-danger ms-4" on:click={()=>console.log("cerrar")}><i class="bi bi-x-lg"></i></button> -->
				</div>
			</div>
			
			<table class="table table-sm" border="1">
				<thead>
					<tr>
						<th class="{key==='PA'?'text-danger':''}">PA</th>
						<th class="{key==='COD'?'text-danger':''}" on:click={()=>buscar('COD')}>COD</th>
						<th class="{key==='UNIDAD'?'text-danger':''}">UNIDAD</th>
						<th class="{key==='RVA'?'text-danger':''}">RVA</th>
						<th class="{key==='VOUCHER'?'text-danger':''}">VOUCHER</th>
						<th class="{key==='STATUS'?'text-danger':''}" on:click={()=>buscar('STATUS')}>STATUS</th>
						<th class="{key==='SOCIO'?'text-danger':''}" on:click={()=>buscar('SOCIO')}>SOCIO</th>
						<th class="{key==='APyNOM'?'text-danger':''}" on:click={()=>buscar('APyNOM')}>APyNOM</th>
						<th class="{key==='CHECKIN'?'text-danger':''}">CHECKIN</th>
						<th class="{key==='CHECKOUT'?'text-danger':''}">CHECKOUT</th>
						<th class="{key==='OBS'?'text-danger':''}" on:click={()=>buscar('OBS')}>OBS</th>
						<th class="{key==='PAX'?'text-danger':''}">PAX</th>
						<th></th>
						<th><small>Estado</small></th>
					</tr>
				</thead>
				<tbody>
					{#each rooming as vou, index}
						<tr>
							<td class="text-white">
								<button class="btn btn-light btn-sm" title="Preasignar unidad" on:click={()=>preasignar(vou.RVA)}>{vou.PA}</button>
							</td>
							<td nowrap>{vou.COD}</td>
							<td class="text-white">{vou.UNIDAD}</td>
							<td class="text-end">{vou.RVA}</td>
							<td class="text-end">{vou.VOUCHER}</td>
							<td >{vou.STATUS}</td>
							<td class="text-end">{vou.SOCIO}</td>
							<td nowrap >({vou.IDCU}){vou.APyNOM||''}</td>
							<td >{vou.CHECKIN}</td>
							<td >{vou.CHECKOUT}</td>
							<td on:click={()=>verObsV=vou.RVA} on:mouseleave={()=>verObsV=0}>{vou.OBS}</td>
							<td>{vou.Adultos+vou.Menores} {vou.CantidadFlex?' (F'+ vou.AdultosFlex +')':''}</td>
							<td>{vou.cantidad}</td>
							<td><small>({vou.estado})</small></td>
						</tr>
						{#if verObsV===vou.RVA}
							<tr>
								<td colspan=10></td>
								<td colspan="3" class="bg-light text-danger">{vou.OBSV||'Sin Observaciones en voucher'}</td>
							</tr>
						{/if}
					{/each}
				</tbody>
			</table>
		{/if}
	</div>

</div>

{#if voucher_selected>0}
	<ReservaInfo bind:voucher={voucher_selected} />
{/if}